import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/public/images/article/comments.svg");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/public/images/article/hearts.svg");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/app/[locale]/page-view-event.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/back-link/back-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/inputs/inline-search/inline-search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/layout/layout/footer/footer.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/layout/layout/main/main.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/layout/layout/navbar/links/links.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/layout/layout/navbar/logo/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/layout/layout/navbar/profile/profile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/layout/layout/navbar/wrapper/wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/popular-jobs/client-side-popular-jobs.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/suggestions-carousel/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/post/body.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/post-comments-and-likes/post-comments-and-likes.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/modules/post/comments/comments-list.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/post/cover.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/post-comments-and-likes/label.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/post/header/header.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/modules/post/header/social-share.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/modules/post/post-info.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/post/summary.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/post/title.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/post/post.module.scss");
